import {remCalc} from '_themeUtils'
import topbar from './partials/topbar'
import menu from './partials/menu/menu'
import sidebar from './partials/sidebar'
import searchSection from './partials/search-section/search-section'
import banner from './partials/banner'
import accessibilityBanner from './partials/accessibility-banner'

const headerBase = {
    Header: {
        baseStyle: ({isTransparentMode}: {isTransparentMode: boolean}) => ({
            header: {
                w: 'full',
                position: 'fixed',
                top: 0,
                zIndex: 1101, // Sticky + 1 to avoid conflict with search section and fixed bottom buttons in Wishlist
                bg: {base: 'color.background.header.default', xl: isTransparentMode && 'color.background.header.gradient'},
                borderBottom: !isTransparentMode && `${remCalc(1)} solid`,
                borderBottomColor: {base: 'color.border.header.default'},
            },
        }),
    },
}

const header = {
    ...headerBase,
    ...topbar,
    ...menu,
    ...sidebar,
    ...searchSection,
    ...banner,
    ...accessibilityBanner,
}

export default header
